import {initMovingLine} from '../../common/moving-line';
import {DURATION} from './constants';

const changeLabelColor = ( input, isPaint ) => {
	const label = input.nextElementSibling;
	
	if ( label && label.tagName.toLowerCase() === 'label' )
	{
		if ( isPaint )
		{
			const color = input.dataset.placemarkTypeColor;
			
			label.style.setProperty( 'background-color', color );
		}
		else
		{
			label.style.removeProperty( 'background-color' );
		}
	}
};

const setInitMapPosition = ( yandexMapHelper ) => {
	yandexMapHelper.yandexMap.setCenter(
		yandexMapHelper.initCenter,
		yandexMapHelper.initZoom,
		{
			duration: DURATION,
		},
	);
};

const applyBounds = ( yandexMapHelper ) => {
	const bounds = yandexMapHelper.yandexMap.geoObjects.getBounds();
	
	if ( bounds ) {
		yandexMapHelper.yandexMap.setBounds(
			bounds,
			{checkZoomRange: true, duration: DURATION, useMapMargin: true},
		);
	}
	else
	{
		setInitMapPosition( yandexMapHelper );
	}
};

const changeAllMarkersVisibility = ( managersByTypes, filterInputs, isVisible ) => {
	filterInputs.forEach( ( filterInput ) => {
		const typeId = filterInput.id;
		
		filterInput.checked = false;
		changeLabelColor( filterInput, false );
		
		managersByTypes[typeId].setFilter( () => isVisible );
	} );
};

const displayAllMarkers = ( managersByTypes, filterInputs ) => {
	changeAllMarkersVisibility( managersByTypes, filterInputs, true );
};

const hideAllMarkers = ( managersByTypes, filterInputs, allFilterInput ) => {
	allFilterInput.checked = false;
	
	changeAllMarkersVisibility( managersByTypes, filterInputs, false );
};

const initFiltersScript = ( yandexMapHelper, managersByTypes ) => {
	const filterPanel = yandexMapHelper.component.querySelector( 'ul.filters' );
	
	if ( filterPanel )
	{
		const allFilterInput = filterPanel.querySelector( 'input#infrastructure-type-all' );
		const filterInputs = Array.from(
			filterPanel.querySelectorAll( 'ul.filters > li > input' ),
		).filter( ( filter ) => filter !== allFilterInput );
		
		filterPanel.addEventListener( 'click', ( evt ) => {
			const input = evt.target.closest( 'input' );
			
			/* Временная необходимость */
			// console.log('click filter', evt );
			
			if ( input ) {
				/* Временная необходимость */
				// console.log( 'click filter сheckbox', evt );
				
				if ( input === allFilterInput )
				{
					displayAllMarkers( managersByTypes, filterInputs );
				}
				else
				{
					const status = input.checked;
					
					if ( allFilterInput.checked )
					{
						hideAllMarkers( managersByTypes, filterInputs, allFilterInput );
						
						input.checked = status;
					}
					
					const manager = managersByTypes[input.id];
					
					if ( status ) {
						manager.setFilter( () => status );
					}
					else
					{
						manager.setFilter( () => status );
					}
					
					changeLabelColor( input, status );
				}
				
				yandexMapHelper.closeBalloon();
				applyBounds( yandexMapHelper );
			}
		} );
		
		/* Кастыль инициирования начального положения фильтров, до появления состояния */
		allFilterInput.checked = true;
		filterInputs.forEach( ( filterInput ) => {
			filterInput.checked = false;
		} );
	}
};

const initFilters = ( yandexMapHelper, managersByTypes ) => {
	const filtersWrapper = yandexMapHelper.component.querySelector( 'div.filters-wrapper' );
	const filtersLine = yandexMapHelper.component.querySelector( 'ul.filters' );
	
	if ( filtersWrapper && filtersLine )
	{
		initMovingLine( filtersWrapper, filtersLine );
		
		filtersWrapper.classList.remove( 'hide' );
		
		initFiltersScript( yandexMapHelper, managersByTypes );
	}
};

export {
	initFilters,
};
